import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../../contexts/AuthContext";

export default function AppleCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { appleLogin } = useAuth();

  useEffect(() => {
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      toast.error("Apple sign-in cancelled or failed");
      navigate("/login");
      return;
    }

    if (!code) {
      toast.error("Apple code missing");
      navigate("/login");
      return;
    }

    appleLogin(code)
      .then(() => navigate("/"))
      .catch(() => navigate("/login"));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      Signing in with Apple...
    </div>
  );
}